
export const MAX_TIME = 180;

export function padFunction(number: string) {
    let string = String(number);
    let sliced = string.slice(-4);
    let mask = String(sliced).padStart(string.length, "*");
    return mask;
}

export function maskEmail(email: string): string {
    let str = email.split("");
    let finalArr: string[] = [];
    let len = str.indexOf("@");

    str.forEach((item, pos) => {
        pos >= 1 && pos <= len - 2 ? finalArr.push("*") : finalArr.push(str[pos]);
    });

    return finalArr.join("");
}